import type { Address } from '@/modules/address/domain/Address';
import type { AddressRepository } from '@/modules/address/domain/AddressRepository';

const setDefaultAddress = (
  repository: AddressRepository,
  addressId: Address['id']
): Promise<Address> => {
  return repository.setDefaultAddress(addressId);
};

export default setDefaultAddress;
